import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import AdslPlanForm from '../forms/AdslPlanForm'
import ThingsToKnow from './ThingsToKnow'
import PaymentInformation from './PaymentInformation'
import globals from '../globals'

class ChangePlanAdsl extends React.Component {
    constructor (props) {
        super(props)

        this.type = 'adsl'

        this.state = {
            isLoaded: false,
            hasError: false,
            plan: {}
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getBroadbandPlans/${this.props.serviceId}`, result => {
		    if (result.plans.length > 0) {
                this.setState({
                    plan: result.plans[0],
                    isLoaded: true
                })
            }
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        return (
            <div>
                <div className='change-plan-adsl module'>
                    <Heading title='Change my plan' />
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError}>
                        <div className='p-4'>
                            <AdslPlanForm
                                serviceId={this.props.serviceId}
                                serviceDetails={this.props.serviceDetails}
                                plan={this.state.plan}
                                handleSuccess={() => globals.pushEvent('AdslPlanChangeSubmit')}
                            />
                        </div>
                    </ModuleWithLoader>
                </div>
                <PaymentInformation />
                <ThingsToKnow type='changePlanAdsl' />
            </div>
        )
    }
}

export default ChangePlanAdsl



// WEBPACK FOOTER //
// ./resources/js/modules/ChangePlanAdsl.js